import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Static route labels only: never put customer data, IDs, tokens or queries in tabs.
const ROUTE_TITLES: Readonly<Record<string, string>> = {
  '/dashboard': 'InkTap — Home',
  '/tap': 'InkTap — Tap Page',
  '/card-design': 'InkTap — Card Design',
  '/cards/design': 'InkTap — Card Design',
  '/card-builder': 'InkTap — Card Design',
  '/builder': 'InkTap — Tap Builder',
  '/orders': 'InkTap — Orders',
  '/analytics': 'InkTap — Analytics',
  '/contacts': 'InkTap — Contacts',
  '/team': 'InkTap — Team',
  '/team/invitations': 'InkTap — Team invitations',
  '/plan-billing': 'InkTap — Plan & Billing',
  '/storage': 'InkTap — Storage usage',
  '/settings': 'InkTap — Settings',
  '/login': 'InkTap — Log in',
  '/create-account': 'InkTap — Create account',
  '/activate': 'InkTap — Activate Card',
  '/organization-invite': 'InkTap — Organization invitation',
  '/admin': 'InkTap Admin — Dashboard',
  '/admin/login': 'InkTap Admin — Log in',
  '/admin/people': 'InkTap Admin — People',
  '/admin/analytics': 'InkTap Admin — Analytics',
  '/admin/links': 'InkTap Admin — Landing Links',
  '/admin/orders': 'InkTap Admin — Orders',
  '/admin/card-products': 'InkTap Admin — Card Products',
  '/admin/commerce': 'InkTap Admin — Commerce',
  '/admin/jobs': 'InkTap Admin — Jobs',
  '/admin/erasure': 'InkTap Admin — Erasure',
  '/admin/assets': 'InkTap Admin — Assets',
  '/admin/billing': 'InkTap Admin — Billing',
  '/admin/accounting': 'InkTap Admin — Accounting',
  '/admin/security': 'InkTap Admin — Sign-in security',
  '/admin/settings': 'InkTap Admin — Settings',
  '/admin/health': 'InkTap Admin — Health',
  '/admin/support': 'InkTap Admin — Support'
};

export function getRouteDocumentTitle(pathname: string): string {
  if (!pathname.startsWith('/')) return 'InkTap';
  // Match the router's case-insensitive paths and optional trailing slash.
  const route = pathname.replace(/\/+$/, '').toLowerCase() || '/';
  return ROUTE_TITLES[route] ?? 'InkTap';
}

export function RouteDocumentTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = getRouteDocumentTitle(pathname);
  }, [pathname]);

  return null;
}
